import queryString from 'query-string';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getSocialMediaServiceOAuthUrlFromType = (type, returnPath) => {
    var _a, _b;
    switch (type) {
        case 'twitch': {
            const isNextJsApp = typeof window !== 'undefined' && ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.startsWith('ui-'));
            const params = {
                return_path: returnPath,
                originating_host: isNextJsApp ? window.location.host : undefined,
            };
            const qs = queryString.stringify(params);
            return `${SYMFONY_API_BASE_URL}/oauth/twitch/authorize${qs ? `?${qs}` : ''}`;
        }
        default:
            throw new Error(`Invalid social media type: ${type}`);
    }
};
export default getSocialMediaServiceOAuthUrlFromType;
